"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CarouselPagination = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var classnames_1 = __importDefault(require("classnames"));
var CarouselPagination = function (_a) {
    var activeIndex = _a.activeIndex, goTo = _a.goTo, length = _a.length, overlay = _a.overlay, pageLarge = _a.pageLarge, _b = _a.shape, shape = _b === void 0 ? 'dot' : _b;
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: __spreadArray([], Array(length), true).map(function (item, index) { return ((0, jsx_runtime_1.jsx)("button", { className: (0, classnames_1.default)("carousel-page carousel-page-".concat(shape), pageLarge && "carousel-page-".concat(shape, "-lg"), overlay && 'carousel-page-overlay', index === activeIndex && 'active'), onClick: function () { return goTo(index); }, "aria-label": "Slide ".concat(index + 1) }, index + 1)); }) }));
};
exports.CarouselPagination = CarouselPagination;
